// extracted by mini-css-extract-plugin
export default {"App":"Header_App__91poS","root":"Header_root__ITbFF","avatar":"Header_avatar__ZJGGJ"};